// applies tailwind themes using css variables
import React from 'react';

import type { IThemeValues } from '../../store/theme';

const shades = Object.freeze([50, 100, 200, 300, 400, 500, 600, 700, 800, 900] as const);

const useSetThemeVariable = (portion: keyof IThemeValues, colour?: string) => {
  React.useEffect(() => {
    if (!colour) {
      return;
    }

    shades.forEach((i) => {
      document.documentElement.style.setProperty(
        `--color-${portion}-${i}`,
        `var(--color-${colour}-${i})`
      );
    });
  }, [portion, colour]);
};

const useTheme = (theme: Partial<IThemeValues>) => {
  const { accent, primary, secondary } = theme;

  useSetThemeVariable('primary', primary);
  useSetThemeVariable('secondary', secondary);
  useSetThemeVariable('accent', accent);
};

export default useTheme;
